// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  return localStorage.getItem('userData')
}

export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

export const setUserData = user => localStorage.setItem('userData', JSON.stringify(user));
export const setUserToken = token => localStorage.setItem('userToken', token);
export const getUserToken = () => localStorage.getItem('userToken');
export const setRefreshToken = token => localStorage.setItem('refreshToken', token);

export const canNavigate = to => to.matched.some(route => route.meta.requiresAuth && route.meta.roles.includes(getUserData().role))

export const clearUserData = ()=> localStorage.removeItem('userData');localStorage.removeItem('userToken');localStorage.removeItem('refreshToken')

export const _ = undefined

export const hasOwnProperty = (o, k) => Object.prototype.hasOwnProperty.call(o, k);

export const resolve= (obj, field, defaultValue = '') => field.split('.').reduce((o, k) => o?.[k], obj) ?? defaultValue;

export const isString = x => typeof x === 'string';
export const isBool = x => typeof x === 'boolean';
export const isArray = x => Array.isArray(x);

export const abilityCheck = function (userAbilities, rules) {
  if (isString(rules) && rules === '*') return true;
  if (isBool(rules)) return rules;
  let hasAllowed = false;

  if (isString(rules) && rules.includes('|')) {
    rules.split('|').forEach(rule => {
      if (userAbilities.includes(rule)) hasAllowed = true;
    })
    if (hasAllowed) return true;
  }

  if (!isArray(rules)) {
    rules = [rules]
  }

  rules.forEach(rule => {
    if (rule === '*' || rule === true) hasAllowed = true;
  })
  if (hasAllowed) return true;

  return rules.reduce((v, rule) => v && userAbilities.includes(rule), true);
}
